export default "__VITE_ASSET__fd622e81__"